import React from "react";

// STYLES
import * as Style from "./RentStatisticElementStyle";

// LIBRARIES

// MISC
import { IProps } from "./RentStatisticElementModel";

// ASSETS

// REDUX

// COMPONENTS

const RentStatistic = (props: IProps) => {

  // PROPS
  const { onClick = () => {}, image = "", title = "", value = 0 } = props;

  // CONSTANTS USING LIBRARIES

  // CONSTANTS USING HOOKS

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS

  return <Style.RentStatisticElement onClick={onClick}>
    <Style.RentStatisticElementContent>
      <Style.ImageContainer>
        <img src={image} alt=""/>
      </Style.ImageContainer>
      <Style.TextContainer>
        <Style.TextContainerSubtitle>
          {title} 
        </Style.TextContainerSubtitle>
        <Style.TextContainerInfo>
          {value}
        </Style.TextContainerInfo>
      </Style.TextContainer>
    </Style.RentStatisticElementContent>
  </Style.RentStatisticElement>
};

export default RentStatistic;